export type SortDirection = 'asc' | 'desc';

export const compareText = (left: unknown, right: unknown, direction: SortDirection = 'asc') => {
  const result = String(left ?? '').localeCompare(String(right ?? ''), 'pt-BR', { sensitivity: 'base' });
  return direction === 'asc' ? result : -result;
};

export const compareDate = (left: unknown, right: unknown, direction: SortDirection = 'desc') => {
  const leftTime = left ? Date.parse(String(left)) : Number.NaN;
  const rightTime = right ? Date.parse(String(right)) : Number.NaN;
  const safeLeft = Number.isFinite(leftTime) ? leftTime : direction === 'asc' ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
  const safeRight = Number.isFinite(rightTime) ? rightTime : direction === 'asc' ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
  const result = safeLeft - safeRight;
  return direction === 'asc' ? result : -result;
};

export const stableSort = <T>(items: T[], compare: (left: T, right: T) => number) =>
  items.map((item, index) => ({ item, index })).sort((left, right) => compare(left.item, right.item) || left.index - right.index).map(({ item }) => item);
